import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance2,
  API_END_POINTS,
} from 'api';

import { MESSAGES } from 'appconstants';

import {
  PLANV2DETAILS,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchPlanV2Details = async gid => axiosAuthInstance2.get(`${API_END_POINTS.PLAN}/${gid}`);

const fetchPlanV2Subscription = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const queryParam = `&plan2Gid.EQ=${payload.gid}`;
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  return axiosAuthInstance2.get(`${API_END_POINTS.SUBSCRIPTION}${query}${queryParam}${sorting}`);
};

export function* getPlanV2Details(action) {
  try {
    yield put({ type: LOADING.SET });
    const { data: { entity } } = yield call(fetchPlanV2Details, action.payload);
    yield put({ type: PLANV2DETAILS.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: PLANV2DETAILS.FAILED, payload: e.response.data });
  } finally {
    yield put({ type: LOADING.UNSET });
  }
}

export function* getPlanV2Payments(action) {
  try {
    const { data: { entity } } = yield call(fetchPlanV2Subscription, action.payload);
    yield put({ type: PLANV2DETAILS.PAYMENTS_SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: PLANV2DETAILS.FAILED, payload: e.response.data });
  }
}
